import { Routes, Route } from "react-router-dom";
import AdminLayout from "../layout/AdminLayout";
import ProtectedRoute from "../components/ProtectedRoute";

// Import Pages
import Dashboard from "../pages/Dashboard";
import Chat from "../pages/Chat";
import Users from "../pages/Users";

// Import Admin Pages
import Pages from "../pages/admin/Pages";
import Legal from "../pages/admin/Legal";
import Faqs from "../pages/admin/Faqs";
import Gifts from "../pages/admin/Gifts";
import Avatars from "../pages/admin/Avatars";
import Offers from "../pages/admin/Offers";
import Rooms from "../pages/admin/Rooms";
import LiveStreaming from "../pages/admin/LiveStreaming";
import Bookmarks from "../pages/admin/Bookmarks";
// import Likes from "../pages/admin/Likes";
import UserUploads from "../pages/admin/UserUploads";
import DeletionRequests from "../pages/admin/DeletionRequests";
import AbuseReports from "../pages/admin/AbuseReports";
import Notifications from "../pages/admin/Notifications";
import Support from "../pages/admin/Support";
import CoinRecords from "../pages/admin/CoinRecords";
import Currencies from "../pages/admin/Currencies";
import Withdrawals from "../pages/admin/Withdrawals";
import SignupReward from "../pages/admin/SignupReward";
import SpinWheel from "../pages/admin/SpinWheel";
import KycRequests from "../pages/admin/KycRequests";
import Settings from "../pages/admin/Settings";

const AdminRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={
        <ProtectedRoute>
          <AdminLayout />
        </ProtectedRoute>
      }>
        {/* Dashboard */}
        <Route index element={<Dashboard />} />

        {/* Pages Section */}
        <Route path="pages" element={<Pages />} />
        <Route path="legal" element={<Legal />} />
        <Route path="faqs" element={<Faqs />} />
        <Route path="gifts" element={<Gifts />} />
        <Route path="avatars" element={<Avatars />} />
        <Route path="offers" element={<Offers />} />
        <Route path="rooms" element={<Rooms />} />
        <Route path="live-streaming" element={<LiveStreaming />} />

        {/* User Management */}
        <Route path="users" element={<Users />} />
        <Route path="kyc" element={<KycRequests />} />
        <Route path="kyc-verifications" element={<KycRequests />} />
        <Route path="bookmarks" element={<Bookmarks />} />
        {/* <Route path="likes" element={<Likes />} /> */}
        <Route path="user-uploads" element={<UserUploads />} />
        <Route path="deletion-requests" element={<DeletionRequests />} />
        <Route path="abuse-reports" element={<AbuseReports />} />

        {/* Support */}
        <Route path="support" element={<Support />} />

        {/* Monetization */}
        <Route path="coin-records" element={<CoinRecords />} />
        <Route path="currencies" element={<Currencies />} />
        <Route path="withdrawals" element={<Withdrawals />} />
        <Route path="signup-reward" element={<SignupReward />} />
        <Route path="spin-wheel" element={<SpinWheel />} />

        {/* Notification */}
        <Route path="notifications" element={<Notifications />} />

        {/* Settings */}
        <Route path="settings" element={<Settings />} />
        <Route path="security" element={<Settings />} />

        {/* Legacy route for backward compatibility */}
        <Route path="chat" element={<Chat />} />
      </Route>
    </Routes>
  );
};

export default AdminRoutes;